"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "20", height: "18", viewBox: "0 0 20 18", className: "Icon nav-antenna", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { fill: "#777", fillRule: "evenodd" },
            _react2.default.createElement("path", { d: "M2.147 6.688c0-1.99.772-3.857 2.176-5.26A.674.674 0 1 0 3.37.474c-3.426 3.427-3.426 9.002 0 12.428a.672.672 0 0 0 .953 0 .674.674 0 0 0 0-.954 7.389 7.389 0 0 1-2.176-5.26" }),
            _react2.default.createElement("path", { d: "M5.237 6.688c0-1.37.532-2.656 1.498-3.622a.674.674 0 0 0-.953-.953 6.477 6.477 0 0 0 0 9.149.67.67 0 0 0 .476.197.672.672 0 0 0 .477-1.149 5.087 5.087 0 0 1-1.498-3.622M17.343.474a.676.676 0 0 0-.953 0 .677.677 0 0 0 0 .954 7.383 7.383 0 0 1 2.176 5.26c0 1.99-.772 3.858-2.176 5.26a.673.673 0 0 0 0 .954.671.671 0 0 0 .953 0c3.426-3.427 3.426-9.002 0-12.428" }),
            _react2.default.createElement("path", { d: "M14.93 2.113a.673.673 0 1 0-.952.953 5.13 5.13 0 0 1 0 7.244.669.669 0 0 0-.001.951.665.665 0 0 0 .477.198.67.67 0 0 0 .477-.197 6.477 6.477 0 0 0 0-9.149" }),
            _react2.default.createElement("path", { d: "M9.672 10.192c.483.098.886.098 1.369 0v6.174c0 .149-.13.279-.28.279h-.81a.286.286 0 0 1-.28-.28v-6.173zm.685-5.733c1.229 0 2.229 1 2.229 2.229s-1 2.229-2.23 2.229-2.23-1-2.23-2.23c0-1.228 1-2.228 2.23-2.228zm0-1.35a3.582 3.582 0 0 0-3.578 3.579c0 1.176.577 2.273 1.546 2.942v6.736c0 .897.73 1.626 1.626 1.626h.81c.897 0 1.627-.73 1.627-1.626V9.63a3.573 3.573 0 0 0 1.547-2.942 3.583 3.583 0 0 0-3.578-3.578z" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/nav-antenna.js
// module id = 1865
// module chunks = 0